export default "__VITE_ASSET__C1_1r3a8__"